<script setup lang="ts">
import RowItemButton, { RowItemButtonProps } from '@/molecules/RowItemButton.vue';
import BaseRadioButton from '@/atoms/BaseRadioButton.vue';

const selectedValue = defineModel<unknown>();

const props = defineProps<
  RowItemButtonProps & { initialChecked?: boolean; value: unknown; allowDeselect?: boolean }
>();

function onClick() {
  const optionValue = props.value ?? props.id;
  selectedValue.value =
    props.allowDeselect && optionValue === selectedValue.value ? undefined : optionValue;
}
</script>

<template>
  <RowItemButton v-bind="props" :selected="(props.value ?? id) === selectedValue" @click="onClick">
    <BaseRadioButton
      colorMode="on-brand"
      v-model="selectedValue"
      :initial-checked="initialChecked"
      :value="value ?? id"
    />
  </RowItemButton>
</template>
